// components/common/TourContext.js
import React, { createContext, useRef, useContext } from "react";

const TourContext = createContext();

export const useTour = () => useContext(TourContext);

export const TourProvider = ({ children }) => {
  const tourRefs = useRef({}); // Store refs per page

  const registerTourRef = (pageKey, ref) => {
    tourRefs.current[pageKey] = ref;
  };

  const startTourForPage = (pageKey) => {
    tourRefs.current[pageKey]?.startTour?.();
  };

  return (
    <TourContext.Provider value={{ registerTourRef, startTourForPage }}>
      {children}
    </TourContext.Provider>
  );
};
